import { OrchestrationSnowflakeAuthType } from '@common/Fabric/types/orchestration';
import { useProviderForm } from '@pages/Fabric/common/ProviderFormContext';
import { UnifiedSnowflakeFormData } from '@pages/Fabric/types';
import { UseFormReturn } from 'react-hook-form';

import { AuthStateCard } from '../AuthCard';
import { ReadOnlyFabricView, ReadOnlySection } from '../ReadOnlyFabricView';
import { getAuthBadge, hasAuthStateCard } from '../utils';

const SNOWFLAKE_AUTH_LABELS: Record<string, string> = {
  [OrchestrationSnowflakeAuthType.PWD]: 'Username & Password',
  [OrchestrationSnowflakeAuthType.KEY_PAIR]: 'Key-pair',
  [OrchestrationSnowflakeAuthType.OAUTH]: 'OAuth',
  [OrchestrationSnowflakeAuthType.OIDC]: 'OIDC'
};

export const SnowflakeReadOnlyView = () => {
  const { formContext, fabricAuthState } = useProviderForm();
  const sfFormContext = formContext as unknown as UseFormReturn<UnifiedSnowflakeFormData>;
  const unifiedFabricData = sfFormContext.watch('unifiedFabricData');

  if (!unifiedFabricData) {
    return null;
  }

  const isOAuth = unifiedFabricData.authType === OrchestrationSnowflakeAuthType.OAUTH;
  const showAuthSection = isOAuth || hasAuthStateCard(fabricAuthState ?? null);

  const sections: ReadOnlySection[] = [
    {
      rows: [
        { label: 'Account URL', value: unifiedFabricData.accountURL },
        {
          label: 'Auth Method',
          value: SNOWFLAKE_AUTH_LABELS[unifiedFabricData.authType] ?? unifiedFabricData.authType ?? '—'
        }
      ]
    },
    ...(showAuthSection
      ? [
          {
            title: 'Authentication',
            badge: fabricAuthState ? getAuthBadge(fabricAuthState) : undefined,
            content: <AuthStateCard authState={fabricAuthState ?? null} provider='Snowflake' />
          }
        ]
      : []),
    {
      title: 'SQL Warehouse',
      badge: { label: 'Configured', variant: 'success' },
      rows: [
        { label: 'Warehouse', value: unifiedFabricData.warehouse },
        { label: 'Database', value: unifiedFabricData.database },
        { label: 'Schema', value: unifiedFabricData.schema }
      ]
    }
  ];

  return <ReadOnlyFabricView sections={sections} />;
};
